//个人信息
const userInfoUrl = `/gateway/hc-mini/user/mini/user-info`;
export { userInfoUrl };
